export default "__VITE_ASSET__CULuDhiH__"